export default "__VITE_ASSET__cc0fbc1e__"